// src/org/OrgContext.js
import React, { createContext, useContext, useMemo, useState } from 'react';

const OrgContext = createContext();

export function OrgProvider({ children }) {
  const [org, setOrg] = useState(() => localStorage.getItem('org') || '');
  const value = useMemo(() => ({ org, setOrg }), [org]);
  return <OrgContext.Provider value={value}>{children}</OrgContext.Provider>;
}

export function useOrg(){
  const ctx = useContext(OrgContext);
  if(!ctx) throw new Error('useOrg must be used within OrgProvider');
  return ctx;
}
export const ORG_CHOOSER_PATH = '/choose';
